<template>
  <MapModal
    :modalNode="modalNode"
    title="添加动画"
    id="animation-update"
    :close="close"
  >
    <template slot="content">
      <div class="screenplay-box">
        <h3>添加动画</h3>
        <el-form
          :inline="true"
          :model="updateData"
          :rules="rules"
          ref="updateData"
          label-width="140px"
        >
          <el-form-item label="选择操作：" prop="operation">
            <el-select
              v-model="updateData.operation"
              placeholder="请选择"
              @change="changeOperation"
            >
              <el-option label="展示" value="show"></el-option>
              <!-- <el-option label="视角飞行" value="flight"></el-option> -->
              <el-option label="环境透明" value="opacity"></el-option>
              <el-option
                label="模型着色 / 透明"
                value="overallStaining"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-row>
            <el-form-item
              label="选择操作类型："
              prop="operationType"
              v-show="updateData.operation"
            >
              <el-select
                v-model="updateData.operationType"
                placeholder="请选择"
                :disabled="operationObjectDisabled"
              >
                <el-option
                  v-for="item in operationType[updateData.operation]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option
              ></el-select>
            </el-form-item>
            <!-- {{ option[updateData.operationType] }} -->
            <el-form-item
              label="选择操作参数："
              prop="operationObject"
              class="is-required"
              v-show="
                updateData.operation == 'show' ||
                  updateData.operation == 'overallStaining'
              "
            >
              <el-cascader
                v-model="updateData.operationObject"
                :options="option[updateData.operationType]"
                :props="{
                  label: 'title',
                  value: 'id',
                  // multiple: true,
                  emitPath: false,
                  expandTrigger: 'hover',
                }"
                multiple
                clearable
                collapse-tags
                leaf="modelColor"
                :show-all-levels="false"
                style="width: 99%;"
                ref="operationCascader"
              ></el-cascader>
            </el-form-item>
            <el-form-item
              label="选择视角："
              prop="flight"
              v-show="updateData.operation == 'flight'"
              class="is-required"
            >
              <el-button type="primary" @click="previous()">
                开始选择
              </el-button>
            </el-form-item>
            <el-form-item
              label="选择透明度："
              prop="opacity"
              v-show="updateData.operation == 'opacity'"
              class="is-required"
            >
              <el-input
                type="number"
                v-model.number="updateData.opacity"
                max="1"
                min="0"
                step="0.1"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item
                label="选择开始时间："
                prop="start"
                v-show="updateData.operation"
              >
                <el-time-picker
                  v-model="updateData.start"
                  :default-value="new Date('1995-02-08 00:00:00')"
                  :picker-options="{
                    selectableRange: selectableRangeFn(),
                  }"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="任意时间点"
                >
                </el-time-picker>
              </el-form-item>
              <el-form-item
                label="结束时间："
                prop="end"
                v-show="updateData.operation"
              >
                <el-time-picker
                  v-model="updateData.end"
                  :default-value="new Date('1995-02-08 00:00:00')"
                  :picker-options="{
                    selectableRange: selectableRangeFn(),
                  }"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="任意时间点"
                >
                </el-time-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="submit">
            <el-button type="primary" @click="submitForm('updateData')">
              确定
            </el-button>
          </div>
        </el-form>
      </div>
    </template>
  </MapModal>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");
export default {
  name: "screenplay-animation-update",
  components: { MapModal },
  props: ["resourceOptions", "sonAnimationData"],
  data() {
    var validatorOperationObject = (rule, value, callback) => {
      if (
        this.updateData.operation == "show" ||
        this.updateData.operation == "overallStaining"
      ) {
        if (value && value != "") {
          callback();
        } else {
          callback(new Error("请选择操作对象"));
        }
      } else {
        callback();
      }
    };
    var validatorOpacity = (rule, value, callback) => {
      if (this.updateData.operation == "opacity") {
        if (value >= 0 && value <= 1) {
          callback();
        } else {
          callback(new Error("数值错误"));
        }
      } else {
        callback();
      }
    };
    return {
      modalNode: {
        program: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 6,
            left: 33,
            unit: "%", // 默认px
          },
          width: "35%", // 宽度配置 默认450px
          height: "390px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      updateData: {
        operation: null,
        operationType: null,
        operationObject: null,
        flight: null,
        opacity: 1,
        start: null,
        end: null,
        presentText: null,
      },
      operationObjectDisabled: false,
      operationType: {
        show: [
          {
            value: "model",
            label: "模型",
          },
          {
            value: "shp",
            label: "SHP",
          },
          {
            value: "kml",
            label: "KML",
          },
          {
            value: "plot",
            label: "标绘",
          },
        ],
        opacity: [
          {
            value: "map",
            label: "地图",
          },
        ],
        flight: [
          {
            value: "map",
            label: "地图",
          },
        ],
        overallStaining: [
          {
            value: "model",
            label: "模型",
          },
        ],
      },
      rules: {
        operation: [
          { required: true, message: "请选择操作", trigger: "change" },
        ],
        operationType: [
          { required: true, message: "请选择操作类型", trigger: "change" },
        ],
        operationObject: [
          { validator: validatorOperationObject, trigger: "change" },
        ],
        opacity: [{ validator: validatorOpacity, trigger: "change" }],
        start: [
          { required: true, message: "请选择开始时间", trigger: "change" },
        ],
        end: [{ required: true, message: "请选择结束时间", trigger: "change" }],
      },
      // option: {
      //   operationObject: {
      //     show: [],
      //     opacity: [],
      //     flight: [],
      //     opacity: [],
      //   },
      // },
    };
  },
  computed: {
    option() {
      console.log("初始数据", this.resourceOptions);
      return {
        model: this.resourceOptions.model,
        kml: this.resourceOptions.kml,
        shp: this.resourceOptions.shp,
        plot: this.resourceOptions.plot,
      };
    },
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },

  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    changeOperation(e) {
      console.log(e);
      switch (e) {
        case "show":
          this.updateData.operationType = "model";
          this.$refs.updateData.validateField("operationObject");
          break;
        case "opacity":
          this.updateData.operationType = "map";
          this.$refs.updateData.validateField("opacity");
          break;
        case "flight":
          this.updateData.operationType = "map";
          this.$refs.updateData.validateField("flight");
          break;
        case "overallStaining":
          this.updateData.operationType = "model";
          this.$refs.updateData.validateField("operationObject");
          break;
      }
      // return model;
    },
    selectableRangeFn() {
      if (this.sonAnimationData.type == 2) {
        return `00:00:00 - ${this.sonAnimationData.totalTime.split(" ")[1]}`;
      } else {
        return "00:00:00 - 23:59:59";
      }
    },
    close() {
      this.$emit("close");
    },
    submitForm(formName) {
      console.log(formName);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (
            this.updateData.operationType == "model" ||
            this.updateData.operationType == "shp" ||
            this.updateData.operationType == "kml" ||
            this.updateData.operationType == "plot"
          ) {
            this.updateData.presentText = this.$refs[
              "operationCascader"
            ].presentText;
          } else if (this.updateData.operationType == "map") {
            this.updateData.presentText = "地图";
          }
          this.$emit("submitUpdate", this.updateData);
          this.close();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    init() {},
  },
  mounted() {
    this.init();
  },
  watch: {
    resourceOptions: {
      handler(newData) {},
      deep: true,
    },
  },
  destroyed() {},
};
</script>
<style lang="scss" scoped>
/deep/ #animation-update {
  background: #0c121e !important;
  h3 {
    color: rgba(255, 255, 255, 0.9) !important;
  }
  .el-scrollbar__wrap {
    margin-top: 0;
    height: auto;
  }
  .tab-first {
    padding: 20px;
  }
  .submit {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 999;
  }
}
</style>
